module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03-en.29198e948801e9ae2ff646b5e3896cde.png";